<template>
  <button
    type="button"
    class="admin-exclusive-result-card"
    :class="{ 'admin-exclusive-result-card--selected': selected }"
    :disabled="disabled || selected"
    :aria-pressed="selected ? 'true' : 'false'"
    @click="$emit('select', project)"
  >
    <span class="admin-exclusive-result-card__cover-wrap">
      <img
        class="admin-exclusive-result-card__cover"
        :src="cover"
        :alt="`Capa de ${projectName}`"
        loading="lazy"
        @error="onImageError"
      />
    </span>

    <span class="admin-exclusive-result-card__body">
      <strong class="admin-exclusive-result-card__title">{{ projectName }}</strong>
      <small class="admin-exclusive-result-card__meta">ID {{ project.id || "-" }}</small>
      <span class="admin-exclusive-result-card__status">
        <v-icon small>{{ selected ? "mdi-check-circle" : "mdi-plus-circle-outline" }}</v-icon>
        {{ selected ? "Ja selecionada" : "Adicionar aos exclusivos" }}
      </span>
    </span>
  </button>
</template>

<script>
import { HOME_PROJECT_FALLBACK, imageWithFallback, setImageFallback } from "@/utils/homeImageFallbacks";

export default {
  name: "AdminExclusiveProjectSearchResultCard",
  props: {
    project: { type: Object, required: true },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    projectName() {
      return this.project.name || this.project.nome || "Obra sem titulo";
    },
    cover() {
      return imageWithFallback(this.project.project_thumb || this.project.cover || this.project.thumb, HOME_PROJECT_FALLBACK);
    },
  },
  methods: {
    onImageError(event) {
      setImageFallback(event, HOME_PROJECT_FALLBACK);
    },
  },
};
</script>

<style src="../../../styles/home-page/admin.css"></style>
